import { RequestFormErrors } from '@app/ui/pages/landing-page/request-form/request-form.types';

const ERROR_MESSAGE = 'Поле обязательно для заполнения';

/**
 * Валидация имени
 * @param value - Значение имени
 * @returns Сообщение об ошибке или undefined
 */
export const validationName = (value: string = ''): string | undefined => {
  const trimmedValue = value.trim();
  
  if (trimmedValue.length === 0) {
    return ERROR_MESSAGE;
  }
  
  if (trimmedValue.length < 2) {
    return 'Имя должно содержать минимум 2 символа';
  }

  return undefined;
};

/**
 * Валидация телефона
 * @param value - Значение телефона
 * @returns Сообщение об ошибке или undefined
 */
export const validationPhone = (value: string = ''): string | undefined => {
  const trimmedValue = value.trim();
  
  if (trimmedValue.length === 0) {
    return ERROR_MESSAGE;
  }
  
  // Проверяем минимальную длину телефона (например, +7 123 456 78 90)
  if (trimmedValue.length < 11) {
    return 'Введите корректный номер телефона';
  }

  return undefined;
};

/**
 * Валидация email (опциональное поле)
 * @param value - Значение email
 * @returns Сообщение об ошибке или undefined
 */
export const validationEmail = (value: string = ''): string | undefined => {
  const trimmedValue = value.trim();
  
  // Email опциональный, если пустой - ошибки нет
  if (trimmedValue.length === 0) {
    return undefined;
  }
  
  // Простая проверка формата email
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(trimmedValue)) {
    return 'Введите корректный email';
  }

  return undefined;
};

/**
 * Валидация адреса
 * @param value - Значение адреса
 * @returns Сообщение об ошибке или undefined
 */
export const validationAddress = (value: string = ''): string | undefined => {
  const trimmedValue = value.trim();
  
  if (trimmedValue.length === 0) {
    return ERROR_MESSAGE;
  }
  
  if (trimmedValue.length < 5) {
    return 'Адрес должен содержать минимум 5 символов';
  }

  return undefined;
};

/**
 * Валидация всех полей формы
 * @param data - Данные формы для валидации
 * @returns Объект с ошибками валидации
 */
export const validate = (data: RequestFormErrors): RequestFormErrors => {
  return {
    name: validationName(data.name),
    address: validationAddress(data.address),
    email: validationEmail(data.email),
    phone: validationPhone(data.phone),
  };
};

/**
 * Проверяет наличие ошибок валидации
 * @param data - Данные формы для проверки
 * @returns true если есть ошибки, false если нет
 */
export const hasError = (data: RequestFormErrors): boolean => {
  const errors = validate(data);

  return Boolean(errors.name || errors.address || errors.email || errors.phone);
};
